import { render, staticRenderFns } from "./ThirdModal.vue?vue&type=template&id=34048b8c"
import script from "./ThirdModal.vue?vue&type=script&lang=js"
export * from "./ThirdModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports